<template>
    <div>
        <el-card class="box-card box-cards" shadow="never">
            <el-row>
                <el-form :inline="true" class="user-search">
                    <el-col :span="24">
                        <el-form-item>
                            <div class="card_top"><span>Banner管理</span></div>
                        </el-form-item>
                        <el-form-item label="搜索：">
                            <el-input size="small" v-model="formInline.params.keyword" placeholder="输入关键字">
                                <el-select v-model="formInline.params.position" slot="prepend" placeholder="位置">
                                    <el-option value="">全部</el-option>
                                    <el-option v-for="item in positions" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                            <el-button size="small" type="primary" plain @click="handleEdit()">添加
                            </el-button>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
        </el-card>
        <el-card class="box-card box-cards2" shadow="never">
            <!--列表-->
            <el-table border ref="multipleTable" :data="tableData" :header-cell-style="headStyle" tooltip-effect="dark"
                style="width: 100%; " v-loading="loading">
                <el-table-column prop="id" label="ID" align="center" width="140"></el-table-column>
                <el-table-column prop="position" label="位置" align="center">
                    <template slot-scope="scope">
                        {{ getPositionName(scope.row.position) }}
                    </template>
                </el-table-column>
                <el-table-column prop="image" label="预览图" align="center">
                    <template slot-scope="scope">
                        <img :src="scope.row.imageUrl" alt="" srcset="" width="60" height="60" />
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="名称" align="center"></el-table-column>
                <el-table-column prop="subtitle" label="描述" align="center"></el-table-column>

                <el-table-column prop="is_show" label="状态" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.status == 0 ? '不显示' : '显示' }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="weight" label="排序" align="center"></el-table-column>
                <el-table-column prop="jtime" label="有效期" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.startTime | timestampToTimes }} - {{ scope.row.endTime | timestampToTimes }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <div>
                            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">修改
                            </el-button>
                            <el-button size="mini" type="danger" @click="handleEditdel(scope.row.id)">删除 </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </el-card>
        <el-drawer :title="title" :visible.sync="editFormVisible" :before-close="handleClose" direction="rtl"
            custom-class="demo-drawer" ref="drawer" size="40%">
            <div class="demo-drawer__content">
                <el-row>
                    <el-form label-width="110px" :model="editForm" :rules="rules" ref="editForm">
                        <el-col :span="22">
                            <div class="grid-content bg-purple">
                                <el-form-item label="位置" prop="position">
                                    <el-select v-model="editForm.params.position" placeholder="请选择Banner位置">
                                        <el-option v-for="item in positions" :key="item.id" :label="item.name"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="标题" prop="name">
                                    <el-input v-model="editForm.params.title" placeholder="请输入标题"></el-input>
                                </el-form-item>
                                <el-form-item label="描述" prop="name">
                                    <el-input v-model="editForm.params.subtitle" placeholder="请输入描述"></el-input>
                                </el-form-item>
                                <el-form-item label="图片" prop="logo">
                                    <el-upload class="avatar-uploader" name="files" :action="imagesrc"
                                        :headers="uploadHeader" :show-file-list="false" :on-success="licenseSuccess"
                                        :before-upload="beforeAvatarUpload">
                                        <img v-if="editForm.params.imageUrl" :src="editForm.params.imageUrl"
                                            class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="链接类型" prop="linkType">
                                    <el-select v-model="editForm.params.linkType" placeholder="请选择链接类型">
                                        <el-option v-for="item in linkTypes" :key="item.id" :label="item.name"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="editForm.params.linkType == 3 ? '参数' : '链接/路径'" prop="name">
                                    <el-input v-model="editForm.params.linkUrl"
                                        :placeholder="editForm.params.linkType == 3 ? '首页留空，产品页和优惠券填写' : '请输入链接/路径'"></el-input>
                                </el-form-item>
                                <el-form-item label="APPID" prop="name">
                                    <el-input v-model="editForm.params.appId"
                                        placeholder="请输入其它小程序/小店的appId，内部跳转留空"></el-input>
                                </el-form-item>
                                <el-form-item label="有效期" prop="name">
                                    <el-date-picker v-model="dateRange" type="daterange" :shortcuts="shortcuts"
                                        format="yyyy-MM-dd" range-separator="To" start-placeholder="Start date"
                                        end-placeholder="End date" />
                                </el-form-item>

                                <el-form-item label="是否显示" prop="name">
                                    <el-radio-group v-model="editForm.params.status">
                                        <el-radio :label="0">不显示</el-radio>
                                        <el-radio :label="1">显示</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="排序" prop="name">
                                    <el-input v-model="editForm.params.weight" placeholder="排序权重"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>

                    </el-form>
                </el-row>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="handleClose">取消</el-button>
                    <el-button size="small" type="goon" :loading="loading" class="title"
                        @click="submitForm('editForm')">
                        保存</el-button>
                </div>
                <div style="height: 60px; margin-top: 50px"></div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import Pagination from "../../components/Pagination";
import debounce from "../../utils/debounce";
import {
    bannerslist,
    bannersdelete,
    bannerscreate,
    bannersdetail,
    bannersupdate,
    bannersupdatesort,
    bannersupdatestatus, imagesrc, getUploadHeader
} from "../../api/userMG";

export default {
    data() {
        return {
            title: "编辑信息",
            positions: [
                { id: 'popup', name: '首页弹窗' },
                { id: 'bottom', name: '首页底部' },
            ],
            linkTypes: [
                { id: 0, name: '自动' },
                { id: 1, name: '小程序' },
                { id: 2, name: '文章链接' },
                { id: 3, name: '小店' },
            ],
            shortcuts: [
                {
                    text: '一个月',
                    value: () => {
                        const start = new Date()
                        const end = new Date()
                        end.setMonth(end.getMonth() + 1)
                        return [start, end]
                    },
                },
                {
                    text: '三个月',
                    value: () => {
                        const start = new Date()
                        const end = new Date()
                        end.setMonth(end.getMonth() + 3)
                        return [start, end]
                    },
                },
                {
                    text: '半年',
                    value: () => {
                        const start = new Date()
                        const end = new Date()
                        end.setMonth(end.getMonth() + 6)
                        return [start, end]
                    },
                },
                {
                    text: '一年',
                    value: () => {
                        const start = new Date()
                        const end = new Date()
                        end.setFullYear(end.getFullYear() + 1)
                        return [start, end]
                    },
                },
            ],
            editFormVisible: false,
            //分页
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10,
            },
            imagesrc: "", //图片
            uploadHeader: {},
            tableData: [], //表格数据 
            types: [],
            formInline: {
                data: {},
                params: {
                    pageNum: 1,
                    pageSize: 10,
                    position: "",
                    keyword: ""
                },
            },
            dialogImageUrl: '',
            dialogVisible: false,
            //添加，修改数据
            editForm: {
                data: {},
                params: {
                    "id": 0,
                    "title": "",
                    "subtitle": "",
                    "position": "",
                    "imageUrl": "",
                    "linkType": 0,
                    "linkUrl": "",
                    "appId": "",
                    "status": 1,
                    "weight": 100
                },
            },
            dateRange: ['', ''],
            //规则验证
            rules: {},
        };
    },
    components: {
        Pagination
    },
    created() {
        this.imagesrc = imagesrc;//上传地址
        this.uploadHeader = getUploadHeader()
        //数据列表
        this.getlist(this.formInline);
    },
    methods: {
        headStyle() {
            return {
                background: "#A1BBFF",
                color: "#fff",
                letterSpacing: "2px",
                border: " 1px solid #A1BBFF",
                textAlign: "center",
                height: "39px",
            };
        },
        getPositionName(pos) {
            for (var i = 0; i < this.positions.length; i++) {
                if (pos == this.positions[i].id) {
                    return this.positions[i].name
                }
            }
            return '-';
        },
        //显示数据
        getlist(parameter) {
            this.loading = true;
            bannerslist(parameter)
                .then((res) => {
                    this.loading = false;
                    // console.log("userlist", res);
                    if (res.code != 200) {
                        this.$message({
                            type: "info",
                            message: res.message,
                        });
                    } else {
                        this.tableData = res.data.records;
                        // 分页赋值
                        this.pageparm.currentPage = this.formInline.params.pageNum;
                        this.pageparm.pageSize = this.formInline.params.pageSize;
                        this.pageparm.total = res.data.total;
                        // console.log(this.tableData)
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("加载失败，请稍后再试！");
                });
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.params.pageNum = parm.currentPage;
            this.formInline.params.pageSize = parm.pageSize;
            this.getlist(this.formInline);
        },
        // 搜索事件
        search() {
            this.formInline.params.pageNum = 1;
            this.getlist(this.formInline); //显示
        },
        //关闭弹框
        handleClose(done) {
            this.$confirm("还有未保存的工作哦确定关闭吗？")
                .then((_) => {
                    this.editFormVisible = false
                    // done();
                })
                .catch((_) => { });
        },
        //上传头像
        licenseSuccess(response, file) {
            this.editForm.params.imageUrl = response.data[0].url
        },
        //限制上传的文件
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            if (!isJPG && !isPNG) {
                this.$message.error('上传图片只能是 JPG 格式或者png格式!');
            }
            return isJPG || isPNG;
        },


        //添加，修改
        handleEdit(index, row) {
            this.editFormVisible = true;
            if (row != undefined && row != "undefined") {//修改

                this.editForm = {

                    data: {},
                    params: {
                        "id": row.id,
                        "title": row.title,
                        "subtitle": row.subtitle,
                        "position": row.position,
                        "imageUrl": row.imageUrl,
                        "linkType": row.linkType,
                        "linkUrl": row.linkUrl,
                        "appId": row.appId,
                        "status": row.status,
                        "weight": row.weight
                    },
                }
                this.dateRange = [
                    row.startTime || '',
                    row.endTime || ''
                ]

            } else {//添加   
                this.editForm = {
                    data: {},
                    params: {
                        "id": 0,
                        "title": "",
                        "subtitle": "",
                        "position": "",
                        "imageUrl": "",
                        "linkType": 0,
                        "linkUrl": "",
                        "appId": '',
                        "status": 1,
                        "weight": 100
                    },
                }
                this.dateRange = ['', '']
            }
        },
        //提交添加，修改
        submitForm(info) {

            debounce(() => {
                var data = JSON.parse(JSON.stringify(this.editForm))
                if (this.dateRange && this.dateRange.length > 1) {
                    data.params.startTime = this.dateRange[0]
                    data.params.endTime = this.dateRange[1]
                } else {
                    data.params.startTime = null
                    data.params.endTime = null
                }
                if (data.params.id == 0) {
                    bannerscreate(data)
                        .then(res => {
                            if (res.code == 200) {
                                this.editFormVisible = false;
                                this.getlist(this.formInline);
                                this.$message({
                                    message: "保存成功！",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    type: "info",
                                    message: res.message,
                                });
                            }
                        })
                        .catch((err) => {
                            this.editFormVisible = false;
                            this.$message.error("保存失败，请稍后再试！");
                        });

                } else {
                    bannersupdate(data)
                        .then(res => {
                            if (res.code == 200) {
                                this.editFormVisible = false;
                                this.getlist(this.formInline);
                                this.$message({
                                    message: "保存成功！",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    type: "info",
                                    message: res.message,
                                });
                            }
                        })
                        .catch((err) => {
                            this.editFormVisible = false;
                            this.$message.error("保存失败，请稍后再试！");
                        });

                }


            }, 1500);
        },
        handleEditdel(id) {
            let data = {
                "data": {},
                "params": { "id": id },
            }
            this.$confirm("确定要删除吗?", "信息", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    bannersdelete(data) //删除
                        .then((res) => {
                            console.log("d", res);
                            if (res.code == 200) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });
                                this.getlist(this.formInline);
                            } else {
                                this.$message({
                                    type: "info",
                                    message: res.message,
                                });
                            }
                        })
                        .catch((err) => {
                            this.loading = false;
                            this.$message.error("删除失败，请稍后再试！");
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },

    },
};
</script>
<style>
@import "../../assets/css/index.css";

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.divBox {
    /*flex-direction: row;*/
    float: left;
    position: relative;
    margin-right: 10px;
}

.imgSty {
    margin-left: 3px;
}

.delIcon {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 20px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 145px;
    height: 145px;
    line-height: 145px;
    text-align: center;
}

.avatar {
    width: 145px;
    height: 145px;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/banners/list.vue